var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import view from './advancedInstruction.view.html';
import './advancedInstruction.scss';
import angular from 'angular';
import inputKeys from '../inputs/inputs.json';
import { translate } from 'angular';
import { AlertService } from 'modules/shared/AlertService';
import { OutputViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/OutputViewModel';
import { variableValueForward } from 'modules/application/detail/portal-submodule-builder/templates/builder/aiAgent/state/Outputs';
import { isValidHistoryLength, isValidTemperatureRange, isValidTokenRange } from '../../../../utils/AgentUtils';
import { role } from '../../../../types/instructions';
import { findConditionOutputs } from '../../../../state/Inputs';
import { BuilderFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import { BuilderStore } from 'modules/application/detail/portal-submodule-builder/templates/builder/store/BuilderStore';
import { AgentHandoffService } from '../../../../services/AgentHandoffService';
import { immutableSplice } from 'data/array';
const builderStore = BuilderStore.getInstance();
let AdvancedInstructionComponent = class AdvancedInstructionComponent {
    static $inject = ['AlertService', '$translate', 'AgentHandoffService'];
    //#endregion
    constructor(AlertService, $translate, AgentHandoffService) {
        this.forwardInput = {};
        this.inputs = Object.keys(inputKeys);
        this.interpretationsEnabled = false;
        // #endregion
        //#region Methods
        this.cancel = async () => {
            if (!this.hasChanges()) {
                this.onClose?.();
            }
            else {
                await this.AlertService.show({
                    title: await this.$translate('advancedInstruction.discardConfigurationAlert.title'),
                    body: await this.$translate('advancedInstruction.discardConfigurationAlert.message'),
                    variant: 'warning',
                    icon: 'warning',
                    buttons: {
                        cancel: await this.$translate('advancedInstruction.discardConfigurationAlert.cancel'),
                        confirm: await this.$translate('advancedInstruction.discardConfigurationAlert.confirm'),
                    },
                    callback: {
                        cancelButtonAction: () => { },
                        confirmButtonAction: async () => { this.confirmDiscard(); },
                    },
                });
            }
        };
        this.AlertService = AlertService;
        this.$translate = $translate;
        this.AgentHandoffService = AgentHandoffService;
    }
    // #endregion
    //#region Lifecycle Hooks
    $onInit() {
        this.initializeState();
    }
    $onChanges(changes) {
        if (changes.agentConfiguration && changes.agentConfiguration.currentValue) {
            this.initializeState();
        }
    }
    // #endregion
    //#region Private Methods
    initializeState() {
        BuilderFeatures.interpretationsEnabled().then(enabled => {
            this.interpretationsEnabled = enabled;
        });
        this.initialState = angular.copy(this.agentConfiguration);
        this.workingConfiguration = angular.copy(this.agentConfiguration);
        this.initialConditionOutputs = angular.copy(this.state.$conditionOutputs);
    }
    updateWorkingConfiguration(updatedConfig) {
        this.workingConfiguration = angular.copy(updatedConfig);
    }
    confirmDiscard() {
        // Undo any temporary forward configuration changes on both input and output.
        // The order of these calls is not significant; they are kept together for clarity.
        // Note: undoForwardOutput() ensures both directions are reverted together.
        this.undoForwardInput();
        this.undoForwardOutput();
        this.workingConfiguration = angular.copy(this.initialState);
        if (this.onClose) {
            this.onClose();
        }
    }
    save() {
        if (this.onSave) {
            this.workingConfiguration.output.forward.handoffName = this.workingConfiguration.output?.forward.enabled ? null : 'enabled';
            const previousConfig = angular.copy(this.agentConfiguration);
            angular.extend(this.agentConfiguration, angular.copy(this.workingConfiguration));
            this.onSave({ $previous: previousConfig });
        }
    }
    hasChanges() {
        return this.hasForwardInputFilled()
            || this.forwardOutputChanged()
            || JSON.stringify(this.workingConfiguration) !== JSON.stringify(this.initialState);
    }
    canSave() {
        return ((this.workingConfiguration.output?.forward.enabled || this.isValidForwardOutput())
            && this.validateModelConfiguration());
    }
    isValidForwardOutput() {
        if (this.workingConfiguration.output?.forward.enabled) {
            return true;
        }
        const currentForwardIndex = this.AgentHandoffService.getHandoffOutputIndex(this.state.$conditionOutputs, variableValueForward);
        const currentStateId = currentForwardIndex >= 0 ? this.state.$conditionOutputs[currentForwardIndex].stateId : null;
        return !!currentStateId;
    }
    forwardOutputChanged() {
        const currentForwardIndex = this.AgentHandoffService.getHandoffOutputIndex(this.state.$conditionOutputs, variableValueForward);
        const initialForwardIndex = this.AgentHandoffService.getHandoffOutputIndex(this.initialConditionOutputs, variableValueForward);
        const currentStateId = currentForwardIndex >= 0 ? this.state.$conditionOutputs[currentForwardIndex].stateId : null;
        const initialStateId = initialForwardIndex >= 0 ? this.initialConditionOutputs[initialForwardIndex].stateId : null;
        return currentStateId !== initialStateId;
    }
    undoForwardOutput() {
        const initialForwardIndex = this.AgentHandoffService.getHandoffOutputIndex(this.initialConditionOutputs, variableValueForward);
        const outputIndex = this.AgentHandoffService.getHandoffOutputIndex(this.state.$conditionOutputs, variableValueForward);
        if (initialForwardIndex >= 0 && outputIndex >= 0) {
            this.state.$conditionOutputs[outputIndex].typeOfStateId = this.initialConditionOutputs[initialForwardIndex].typeOfStateId;
            this.state.$conditionOutputs[outputIndex].stateId = this.initialConditionOutputs[initialForwardIndex].stateId;
            return;
        }
        if (initialForwardIndex < 0 && outputIndex >= 0) {
            // Forward output was added during the session; remove it to restore initial state
            this.state.$conditionOutputs = immutableSplice(this.state.$conditionOutputs, outputIndex, 1);
        }
    }
    hasForwardInputFilled() {
        let forward = false;
        this.inputs.forEach(key => {
            if (this.workingConfiguration?.input?.[key]?.enableInputForwarding) {
                if (!this.forwardInput[key]) {
                    forward = false;
                    return;
                }
                const originalForward = this.initialConditionOutputs.filter(findConditionOutputs(inputKeys[key].variableValueForward))[0] || new OutputViewModel();
                const updateForward = this.state.$conditionOutputs.filter(findConditionOutputs(inputKeys[key].variableValueForward))[0] || new OutputViewModel();
                forward = forward || (originalForward.stateId !== updateForward.stateId);
            }
            else if (this.workingConfiguration.input[key] != null) {
                forward = forward || (this.workingConfiguration.input[key].enableInputForwarding
                    !== this.initialState.input[key].enableInputForwarding);
            }
        });
        return forward;
    }
    undoForwardInput() {
        this.inputs.forEach(key => {
            if (this.workingConfiguration?.input?.[key]?.enableInputForwarding) {
                let originalForward = this.initialConditionOutputs.filter(findConditionOutputs(inputKeys[key].variableValueForward))[0] || new OutputViewModel();
                if (originalForward?.stateId) {
                    const outputIndex = this.state.$conditionOutputs.findIndex(findConditionOutputs(inputKeys[key].variableValueForward));
                    if (outputIndex >= 0 && this.state.$conditionOutputs[outputIndex].stateId !== originalForward.stateId) {
                        this.state.$conditionOutputs[outputIndex].typeOfStateId = originalForward.typeOfStateId;
                        this.state.$conditionOutputs[outputIndex].stateId = originalForward.stateId;
                    }
                }
            }
        });
        builderStore.setState({ ...angular.copy(this.state) });
    }
    validateModelConfiguration() {
        const historyPrompt = this.workingConfiguration.prompt?.find(item => item.type === role.shortTermMemory);
        const validHistory = !historyPrompt ? true : isValidHistoryLength(historyPrompt.config.length);
        return isValidTokenRange(this.workingConfiguration.model.maxTokens) &&
            isValidTemperatureRange(this.workingConfiguration.model.temperature) &&
            validHistory;
    }
};
AdvancedInstructionComponent.$inject = ['AlertService', '$translate', 'AgentHandoffService'];
AdvancedInstructionComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            onClose: '&?',
            onSave: '&?',
            agentConfiguration: '<',
            availableModels: '<',
            stateId: '<',
            state: '=?',
            states: '=?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof AlertService !== "undefined" && AlertService) === "function" ? _a : Object, typeof (_b = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _b : Object, typeof (_c = typeof AgentHandoffService !== "undefined" && AgentHandoffService) === "function" ? _c : Object])
], AdvancedInstructionComponent);
export { AdvancedInstructionComponent };
